<template>
  <b-modal
    :id="id"
    size="md"
    centered
    hide-footer
    @show="onShow"
    @hide="onHide"
  >
    <template #modal-header="{ close }">
      <h5 class="modal-title">{{ title }}</h5>
      <a class="close" @click="close()"><i class="far fa-times-circle fa-2x"></i></a>
    </template>
    <div class="container-fluid no-pad">
      <div class="row mt-2">
        <div class="col-sm-12">
          <label class="font-weight-bold" :for="`${id}-reason`">Reason</label>
          <textarea
            :id="`${id}-reason`"
            v-model="reason"
            class="form-control"
            rows="3"
            :maxlength="maxLength"
            placeholder="Enter a reason for this change"
          ></textarea>
          <small class="d-block text-right text-muted">{{ reason.length }}/{{ maxLength }}</small>
        </div>
      </div>
      <div class="row text-center mt-2">
        <div class="col-sm-12 no-pad">
          <button
            type="button"
            class="btn btn-hc w-40 mr-2 mb-3"
            :disabled="!canSave"
            @click="onSave"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-hc w-40 ml-2 mb-3"
            @click="onCancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// Reason-capture window shown when an operator toggles the Bill Service control
// (SEBL-0041-B 3.1.2). Save is blocked until a non-whitespace reason is entered; Cancel
// (or dismissing the modal) sends nothing and leaves the Bill Service status unchanged.
export default {
  name: 'DoNotBillReasonModal',

  props: {
    id: {
      type: String,
      default: 'donotbill-reason-modal',
    },
    title: {
      type: String,
      default: 'Change Bill Service',
    },
    maxLength: {
      type: Number,
      default: 500,
    },
  },

  data() {
    return {
      reason: '',
      saved: false,
    };
  },

  computed: {
    canSave() {
      return this.reason.trim().length > 0;
    },
  },

  methods: {
    onShow() {
      this.reason = '';
      this.saved = false;
    },

    onHide() {
      // Any dismissal that is not an explicit Save (backdrop click, Esc, close icon)
      // counts as a cancel so the caller never persists without a reason.
      if (!this.saved) {
        this.$emit('cancel');
      }
    },

    onSave() {
      if (!this.canSave) return;
      this.saved = true;
      this.$emit('save', this.reason.trim());
      this.$bvModal.hide(this.id);
    },

    onCancel() {
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
